import styled from 'styled-components';

export const MessageText = styled.div`
	margin-bottom: 1rem;
`;

export const List = styled.ul`
	margin: 0;
	margin-top: 1rem;
`;

export const ListItem = styled.li`
	margin-bottom: 5px;
`;
